// extracted by mini-css-extract-plugin
module.exports = {"title":"InfoSection_title__oIWS8"};